import { type PropsWithChildren } from 'react';

export const Max = ({ children }: PropsWithChildren) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>{children}</>
);

Max['displayName'] = 'MultiMeterBarChart.Max';
